module.exports = new __parcel__URL__("connected_earth_air_quality.33a7467e.png").toString();